import script from "./SectionHeading.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionHeading.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__